import { action } from '@ember/object';
import Component from '@glimmer/component';

export default class ListWeeksBadgeComponent extends Component {
  get value() {
    return this.args.value ?? undefined;
  }

  @action
  onWeekSelect(week) {
    this.args?.onSelect?.(week);
  }
}
